import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HeaderMenus } from '@shared/menus';
import { MenuItemModel } from '@shared/models/menu.model';

@Component({
  selector: 'app-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderMenuComponent implements OnInit {

  headerMenus: MenuItemModel[] = HeaderMenus;
  constructor() { }

  ngOnInit(): void { }
}
